import { createFileRoute, useParams } from "@tanstack/react-router";
import { EntityTypeFormTab } from "@/features/form-editor/components/entity-type-form-tab";

const ROUTE_ID =
	"/_authenticated/(admin-app)/_admin/admin/configuration/recordTypes/$recordTypeId/schema" as const;

export const Route = createFileRoute(ROUTE_ID)({
	component: AdminRecordTypeSchemaTab,
});

function AdminRecordTypeSchemaTab() {
	const { recordTypeId } = useParams({ from: ROUTE_ID });
	return (
		<EntityTypeFormTab entity="record" typeId={recordTypeId} scope="admin" />
	);
}
